// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------
import request from '@/api/request';

/**
 * @description 商品分类 -- 列表
 */
export function storeCategoryListApi() {
  return request({
    url: 'store/category/lst',
    method: 'get',
  });
}

/**
 * @description 店铺类型 -- 获取选择项
 */
export function getstoreTypeApi() {
  return request({
    url: 'merchant/type/options',
    method: 'get',
  });
}

/**
 * @description 商品分类 -- 新增表单
 */
export function storeCategoryCreateApi() {
  return request({
    url: 'store/category/create/form',
    method: 'get',
  });
}

/**
 * @description 商品分类 -- 编辑表单
 */
export function storeCategoryUpdateApi(id: number | string) {
  return request({
    url: `store/category/update/form/${id}`,
    method: 'get',
  });
}

/**
 * @description 商品分类 -- 删除
 */
export function storeCategoryDeleteApi(id: number | string) {
  return request({
    url: `store/category/delete/${id}`,
    method: 'delete',
  });
}

/**
 * @description 商品分类 -- 修改状态
 */
export function storeCategoryStatusApi(id: number | string, status: number) {
  return request({
    url: `store/category/status/${id}`,
    method: 'post',
    data: { status },
  });
}

/**
 * @description 属性规则 -- 列表
 */
export function templateListApi(data: any) {
  return request({
    url: 'store/attr/template/lst',
    method: 'get',
    params: data,
  });
}

/**
 * @description 属性规则 -- 添加
 */
export function attrCreatApi(data: any) {
  return request({
    url: 'store/attr/template/create',
    method: 'post',
    data,
  });
}

/**
 * @description 属性规则 -- 编辑
 */
export function attrEdittApi(id: number | string, data: any) {
  return request({
    url: `store/attr/template/${id}`,
    method: 'post',
    data,
  });
}

/**
 * @description 属性规则 -- 删除
 */
export function attrDeleteApi(id: number | string) {
  return request({
    url: `store/attr/template/${id}`,
    method: 'delete',
  });
}

/**
 * @description 商品添加 -- 属性规则
 */
export function templateLsitApi() {
  return request({
    url: '/store/attr/template/list',
    method: 'get',
  });
}

/**
 * @description 商品列表 -- 列表
 */
export function productLstApi(data: any) {
  return request({
    url: 'store/product/lst',
    method: 'get',
    params: data,
  });
}




/**
 * @description 商品列表 -- 删除
 */
export function productDeleteApi(id: number | string) {
  return request({
    url: `store/product/delete/${id}`,
    method: 'delete',
  });
}

/**
 * @description 商品列表 -- 添加
 */
export function productCreateApi(data: any) {
  return request({
    url: 'store/product/create',
    method: 'post',
    data,
  });
}



/**
 * @description 商品列表 -- 预约商品添加
 */
export function productReservationCreateApi(data: any) {
  return request({
    url: 'store/reservation/product/create',
    method: 'post',
    data,
  });
}

/**
 * @description 商品列表 -- 预约商品编辑
 */
export function productReservationEditApi(id: number | string, data: any) {
  return request({
    url: `store/reservation/product/edit/${id}`,
    method: 'post',
    data,
  });
}

/**
 * @description 商品列表 -- 获取预约商品编辑信息
 */
export function productReservationInfoApi(id: number | string) {
  return request({
    url: `store/reservation/product/edit/${id}`,
    method: 'get',
  });
}

/**
 * @description 商品列表 -- 获取预约商品详情
 */
export function productReservationDetailApi(id: number | string) {
  return request({
    url: `store/reservation/product/detail/${id}`,
    method: 'get',
  });
}

/**
 * @description 商品列表 -- 预览
 */
export function productPreviewApi(data: any) {
  return request({
    url: 'store/product/preview',
    method: 'post',
    data,
  });
}

/**
 * @description 商品列表 -- 复制
 */
export function productCopyApi(data: any) {
  return request({
    url: 'store/productcopy/save',
    method: 'post',
    data,
  });
}

/**
 * @description 秒杀品列表 -- 添加
 */
export function seckillProductCreateApi(data: any) {
  return request({
    url: 'store/seckill_product/create',
    method: 'post',
    data,
  });
}

/**
 * @description 秒杀 -- 预览
 */
export function seckillPreviewApi(data: any) {
  return request({
    url: 'store/seckill_product/preview',
    method: 'post',
    data,
  });
}

/**
 * @description 商品列表 -- 编辑
 */
export function productUpdateApi(id: number | string, data: any) {
  return request({
    url: `store/product/update/${id}`,
    method: 'post',
    data,
  });
}

/**
 * @description 活动列表 -- 编辑
 */
export function activityUpdateApi(id: number | string, data: any) {
  return request({
    url: `store/activity/update/${id}`,
    method: 'post',
    data,
  });
}

/**
 * @description 商品详情-批量设置预约商品库存
 */
export function productSetStockApi(id: number | string, data: any) {
  return request({
    url: `store/reservation/product/setStock/${id}`,
    method: 'post',
    data,
  });
}

/**
 * @description 商品 -- 详情
 */
export function productDetailApi(id: number | string, data: any) {
  return request({
    url: `store/product/detail/${id}`,
    method: 'get',
    params: data,
  });
}

/**
 * @description 商品列表 -- 详情
 */
export function productLstDetail(id: number | string, data: any) {
  return request({
    url: `store/product/get_edit/${id}`,
    method: 'get',
    params: data,
  });
}


/**
 * @description 秒杀商品 -- 详情
 */
export function seckillProductDetailApi(id: number | string) {
  return request({
    url: `store/seckill_product/detail/${id}`,
    method: 'get',
  });
}

/**
 * @description 商品列表 -- 商户分类
 */
export function categorySelectApi() {
  return request({
    url: 'store/category/select',
    method: 'get',
  });
}

/**
 * @description 商品列表 -- 平台分类
 */
export function categoryListApi() {
  return request({
    url: 'store/category/list',
    method: 'get',
  });
}



/**
 * @description 商品列表 -- 品牌分类
 */
export function categoryBrandListApi() {
  return request({
    url: 'store/category/brandlist',
    method: 'get',
  });
}

/**
 * @description 商品列表 -- 运费模板筛选
 */
export function shippingListApi() {
  return request({
    url: 'store/shipping/list',
    method: 'get',
  });
}

/**
 * @description 商品列表 -- 列表表头
 */
export function lstFilterApi(data:any) {
  return request({
    url: 'store/product/lst_filter',
    method: 'get',
    params: data,
  });
}

/**
 * @description 商品列表 -- 上下架
 */
export function statusApi(id: number | string, status: number) {
  return request({
    url: `store/product/status/${id}`,
    method: 'post',
    data: { status },
  });
}

/**
 * @description 组件商品列表 -- 列表
 */
export function goodLstApi(data: any) {
  return request({
    url: 'store/product/list',
    method: 'get',
    params: data,
  });
}

/**
 * @description 配置状态
 */
export function productConfigApi() {
  return request({
    url: 'store/product/config',
    method: 'get',
  });
}

/**
 * @description 商品列表 -- 评价列表
 */
export function reviewLstApi(data: any) {
  return request({
    url: 'store/reply/lst',
    method: 'get',
    params: data,
  });
}

/**
 * @description 商品列表 -- 评价回复
 */
export function reviewReplyApi(id: number | string) {
  return request({
    url: `store/reply/form/${id}`,
    method: 'get',
  });
}

/**
 * @description 商品列表 -- 评价回复
 */
export function destoryApi(id: number | string) {
  return request({
    url: `store/product/destory/${id}`,
    method: 'delete',
  });
}

/**
 * @description 商品列表 -- 恢复
 */
export function restoreApi(id: number | string) {
  return request({
    url: `store/product/restore/${id}`,
    method: 'post',
  });
}

/**
 * @description 商品列表 -- 复制商品
 */
export function crawlFromApi(data: any) {
  return request({
    url: 'store/productcopy/get',
    method: 'get',
    params: data,
  });
}

/**
 * @description 秒杀商品 -- 可选时间表
 */
export function seckillProTimeApi() {
  return request({
    url: 'store/seckill_product/lst_time',
    method: 'get',
  });
}

/**
 * @description 复制商品 -- 剩余次数
 */
export function productCopyCountApi() {
  return request({
    url: 'store/productcopy/count',
    method: 'get',
  });
}

/**
 * @description 复制商品 -- 复制记录
 */
export function productCopyRecordApi(data: any) {
  return request({
    url: 'store/productcopy/lst',
    method: 'get',
    params: data,
  });
}

/**
 * @description 预售 -- 添加预售商品
 */
export function preSaleCreateProApi(data: any) {
  return request({
    url: 'store/product/presell/create',
    method: 'post',
    data,
  });
}

/**
 * @description 预售 -- 编辑预售商品
 */
export function preSaleUpdateProApi(id: number | string, data: any) {
  return request({
    url: `store/product/presell/update/${id}`,
    method: 'post',
    data,
  });
}

/**
 * @description 预售 -- 列表
 */
export function preSaleProListApi(data: any) {
  return request({
    url: 'store/product/presell/lst',
    method: 'get',
    params: data,
  });
}

/**
 * @description 预售商品 -- 详情
 */
export function preSaleProDetailApi(id: number | string) {
  return request({
    url: `store/product/presell/detail/${id}`,
    method: 'get',
  });
}

/**
 * @description 预售商品 -- 头部数量
 */
export function preSaleProUnmApi() {
  return request({
    url: 'store/product/presell/number',
    method: 'get',
  });
}

/**
 * @description 预售商品列表 -- 显示状态（上下架）
 */
export function presellStatusApi(id: number | string, status: number) {
  return request({
    url: `store/product/presell/status/${id}`,
    method: 'post',
    data: { status },
  });
}

/**
 * @description 预售商品列表 -- 删除
 */
export function preSellDeleteApi(id: number | string) {
  return request({
    url: `store/product/presell/delete/${id}`,
    method: 'delete',
  });
}

/**
 * @description 预售 -- 预览
 */
export function presellPreviewApi(data: any) {
  return request({
    url: 'store/product/presell/preview',
    method: 'post',
    data,
  });
}

/**
 * @description 拼团 -- 预览
 */
export function groupPreviewApi(data: any) {
  return request({
    url: 'store/product/group/preview',
    method: 'post',
    data,
  });
}

/**
 * @description 助力 -- 添加助力商品
 */
export function assistCreateProApi(data: any) {
  return request({
    url: 'store/product/assist/create',
    method: 'post',
    data,
  });
}

/**
 * @description 助力 -- 编辑助力商品
 */
export function assistUpdateProApi(id: number | string, data: any) {
  return request({
    url: `store/product/assist/update/${id}`,
    method: 'post',
    data,
  });
}

/**
 * @description 助力 -- 列表
 */
export function assistProListApi(data: any) {
  return request({
    url: 'store/product/assist/lst',
    method: 'get',
    params: data,
  });
}

/**
 * @description 助力商品 -- 详情
 */
export function assistProDetailApi(id: number | string) {
  return request({
    url: `store/product/assist/detail/${id}`,
    method: 'get',
  });
}

/**
 * @description 助力 -- 预览
 */
export function assistPreviewApi(data: any) {
  return request({
    url: 'store/product/assist/preview',
    method: 'post',
    data,
  });
}

/**
 * @description 助力商品列表 -- 删除
 */
export function assistDeleteApi(id: number | string) {
  return request({
    url: `store/product/assist/delete/${id}`,
    method: 'delete',
  });
}

/**
 * @description 助力活动 -- 列表
 */
export function assistListApi(data: any) {
  return request({
    url: 'store/product/assist_set/lst',
    method: 'get',
    params: data,
  });
}

/**
 * @description 助力商品列表 -- 显示状态（上下架）
 */
export function assistStatusApi(id: number | string, status: number) {
  return request({
    url: `store/product/assist/status/${id}`,
    method: 'post',
    data: { status },
  });
}

/**
 * @description 助力活动列表 -- 查看详情
 */
export function assistDetailApi(id: number | string, data: any) {
  return request({
    url: `store/product/assist_set/detail/${id}`,
    method: 'get',
    params: data,
  });
}

/**
 * @description 助力活动列表 -- 查看详情
 */
export function productGetTempKeysApi() {
  return request({
    url: 'store/product/temp_key',
    method: 'get',
  });
}

/**
 * @description 普通商品 -- 列表排序
 */
export function productSort(id: number | string, data: any) {
  return request({
    url: `/store/product/sort/${id}`,
    method: 'post',
    data,
  });
}

/**
 * @description 评论 -- 列表排序
 */
export function reviewsSort(id: number | string, data: any) {
  return request({
    url: `/store/reply/sort/${id}`,
    method: 'post',
    data,
  });
}

/**
 * @description 服务保障 -- 添加
 */
export function guaranteeAddApi(data: any) {
  return request({
    url: 'guarantee/create',
    method: 'post',
    data,
  });
}

/**
 * @description 服务保障 -- 列表
 */
export function guaranteeLstApi(data: any) {
  return request({
    url: 'guarantee/lst',
    method: 'get',
    params: data,
  });
}

/**
 * @description 服务保障 -- 编辑排序
 */
export function guaranteeSortApi(id: number | string, data: any) {
  return request({
    url: `guarantee/sort/${id}`,
    method: 'post',
    data,
  });
}

/**
 * @description 服务保障 -- 编辑
 */
export function guaranteeUpdateApi(id: number | string, data: any) {
  return request({
    url: `guarantee/update/${id}`,
    method: 'post',
    data,
  });
}

/**
 * @description 服务保障 -- 详情
 */
export function guaranteeDetailApi(id: number | string) {
  return request({
    url: `guarantee/detail/${id}`,
    method: 'get',
  });
}

/**
 * @description 服务保障 -- 删除
 */
export function guaranteeDeleteApi(id: number | string) {
  return request({
    url: `guarantee/delete/${id}`,
    method: 'delete',
  });
}

/**
 * @description 服务保障 -- 获取平台条款
 */
export function guaranteeSelectApi(data: any) {
  return request({
    url: 'guarantee/select',
    method: 'get',
    params: data,
  });
}

/**
 * @description 服务保障 -- 修改显示状态
 */
export function guaranteeStatusApi(id: number | string, status: number) {
  return request({
    url: `guarantee/status/${id}`,
    method: 'post',
    data: { status },
  });
}

/**
 * @description 添加商品 -- 获取服务保障模板列表
 */
export function guaranteeListApi(params?: { scene?: number; includeId?: number }) {
  return request({
    url: 'guarantee/list',
    method: 'get',
    params,
  });
}

/*
  上传视频（走服务端，由后端按 upload_type 存本地/七牛等）
  超时加长：视频体积大，默认 10s 不够
*/
export function uploadVideoOfLocal(data: any) {
  return request({
    url: 'upload/video',
    method: 'post',
    data,
    timeout: 5 * 60 * 1000,
  });
}

/**
 * @description 标签 -- 新增表单
 */
export function labelCreateApi() {
  return request({
    url: 'product/label/create/form',
    method: 'get',
  });
}

/**
 * @description 标签 -- 编辑表单
 */
export function labelUpdateApi(id: number | string) {
  return request({
    url: `product/label/update/${id}/form`,
    method: 'get',
  });
}

/**
 * @description 标签 -- 列表
 */
export function labelListApi(data: any) {
  return request({
    url: 'product/label/lst',
    method: 'get',
    params: data,
  });
}

/**
 * @description 标签 -- 删除
 */
export function labelDeleteApi(id: number | string) {
  return request({
    url: `product/label/delete/${id}`,
    method: 'delete',
  });
}

/**
 * @description 标签列表 -- 修改状态
 */
export function labelStatusApi(id: number | string, status: number) {
  return request({
    url: `product/label/status/${id}`,
    method: 'post',
    data: { status },
  });
}

/** 商品列表 -- 获取标签项 */
export function getProductLabelApi() {
  return request({
    url: 'product/label/option',
    method: 'get',
  });
}

/** 商品列表 -- 编辑标签 */
export function updatetProductLabel(id: number | string, data: any) {
  return request({
    url: `store/product/labels/${id}`,
    method: 'post',
    data,
  });
}

/** 预售列表 -- 编辑标签 */
export function updatetPresellLabel(id: number | string, data: any) {
  return request({
    url: `store/product/presell/labels/${id}`,
    method: 'post',
    data,
  });
}

/** 助力列表 -- 编辑标签 */
export function updatetAssistLabel(id: number | string, data: any) {
  return request({
    url: `store/product/assist/labels/${id}`,
    method: 'post',
    data,
  });
}

/** 拼团列表 -- 编辑标签 */
export function updatetCombinationLabel(id: number | string, data: any) {
  return request({
    url: `store/product/group/labels/${id}`,
    method: 'post',
    data,
  });
}

/** 商品列表 -- 免审核编辑 */
export function freeTrialApi(id: number | string, data: any) {
  return request({
    url: `store/product/free_trial/${id}`,
    method: 'post',
    data,
  });
}

/** 商品列表 -- 批量上下架 */
export function batchesOnOffApi(data: any) {
  return request({
    url: 'store/product/batch_status',
    method: 'post',
    data,
  });
}

/** 商品列表 -- 批量设置标签 */
export function batchesLabelsApi(data: any) {
  return request({
    url: 'store/product/batch_labels',
    method: 'post',
    data,
  });
}

/** 商品列表 -- 批量设置运费模板 */
export function batchesTempApi(data: any) {
  return request({
    url: 'store/product/batch_temp',
    method: 'post',
    data,
  });
}

/** 参数模板 -- 添加 */
export function productSpecs(data: any) {
  return request({
    url: 'store/params/temp/create',
    method: 'post',
    data,
  });
}

/** 参数模板 -- 编辑 */
export function specsUpdate(id: number | string, data: any) {
  return request({
    url: `store/params/temp/update/${id}`,
    method: 'post',
    data,
  });
}

/** 参数模板 -- 详情 */
export function productSpecsInfo(id: number | string) {
  return request({
    url: `store/params/temp/detail/${id}`,
    method: 'get',
  });
}

/** 参数模板 -- 列表 */
export function productSpecsList(data: any) {
  return request({
    url: 'store/params/temp/lst',
    method: 'get',
    params: data,
  });
}

/** 参数模板 -- 删除 */
export function specsDeteleApi(id: number | string) {
  return request({
    url: `store/params/temp/delete/${id}`,
    method: 'delete',
  });
}

/** 参数模板 -- 详情 */
export function specsDetailApi(id: number | string) {
  return request({
    url: `store/params/temp/detail/${id}`,
    method: 'get',
  });
}

/** 添加商品 -- 参数筛选 */
export function specsSelectedApi(data: any) {
  return request({
    url: 'store/params/temp/select',
    method: 'get',
    params: data,
  });
}

/** 添加商品 -- 参数筛选详情 */
export function productSpecsDetailApi(data: any) {
  return request({
    url: 'store/params/temp/show',
    method: 'get',
    params: data,
  });
}

/** 商品列表 -- 批量设置佣金 */
export function productBathExtApi(data: any) {
  return request({
    url: 'store/product/batch_ext',
    method: 'post',
    data,
  });
}

/** 商品列表 -- 批量设置会员价 */
export function productBathSvipApi(data: any) {
  return request({
    url: 'store/product/batch_svip',
    method: 'post',
    data,
  });
}

/** 商品列表 -- 批量恢复 */
export function productBathRestoreApi(data: any) {
  return request({
    url: 'store/product/batch_restore',
    method: 'post',
    data,
  });
}
/** 商品列表 -- 批量设置保障服务 */
export function productBathGuaranteeApi(data: any) {
  return request({
    url: 'store/product/batch_guarantee',
    method: 'post',
    data,
  });
}
/** 商品列表 -- 批量删除 */
export function productBathDeleteApi(data: any) {
  return request({
    url: 'store/product/batch_delete',
    method: 'delete',
    data,
  });
}

/** 商品列表 -- 立即生成规格 */
export function generateAttrApi(id: number | string, data: any) {
  return request({
    url: `store/product/get_attr_value/${id}`,
    method: 'post',
    data,
  });
}

/** 商品列表 -- 系统表单下拉 */
export function associatedFormList() {
  return request({
    url: 'store/form/select',
    method: 'get',
  });
}

/** 商品列表 -- 系统表单详情 */
export function associatedFormInfo(id: number | string) {
  return request({
    url: `store/form/info/${id}`,
    method: 'get',
  });
}

/** 商品列表 -- 批量设置 */
export function batchSetProduct(data: any) {
  return request({
    url: 'store/product/batch_process',
    method: 'post',
    data,
  });
}

/** 商品列表 -- 商品操作记录 */
export function operateRecordList(id: number | string, data: any) {
  return request({
    url: `store/product/get_operate_list/${id}`,
    method: 'get',
    params: data,
  });
}

/**
 * @description 商品单位 -- 列表
 */
export function unitListApi(data: any) {
  return request({
    url: 'product/unit/list',
    method: 'get',
    params: data,
  });
}

/**
 * @description 商品单位 -- 添加
 */
export function unitCreatApi() {
  return request({
    url: 'product/unit/create/form',
    method: 'get',
  });
}

/**
 * @description 商品单位 -- 编辑
 */
export function unitEdittApi(id: number | string) {
  return request({
    url: `/product/unit/update/${id}/form`,
    method: 'get',
  });
}

/**
 * @description 商品单位 -- 删除
 */
export function unitDeleteApi(id: number | string) {
  return request({
    url: `product/unit/delete/${id}`,
    method: 'delete',
  });
}

/**
 * @description 商品单位 -- 下拉选择
 */
export function unitOptionsApi() {
  return request({
    url: 'product/unit/option',
    method: 'get',
  });
}

/**
 * @description 卡密库 -- 添加卡密库
 */
export function productCdkeysaveApi(data: any) {
  return request({
    url: 'product/cdkey/library/create',
    method: 'post',
    data,
  });
}

/**
 * @description 卡密库 -- 列表
 */
export function productCdkeyListApi(data: any) {
  return request({
    url: 'product/cdkey/library/lst',
    method: 'get',
    params: data,
  });
}

/**
 * @description 卡密库 -- 编辑
 */
export function productUnrelatedUpdateApi(id: number | string, data: any) {
  return request({
    url: `product/cdkey/library/update/${id}`,
    method: 'post',
    data,
  });
}

/**
 * @description 卡密库 -- 删除
 */
export function productCdkeyDeleteApi(id: number | string) {
  return request({
    url: `product/cdkey/library/delete/${id}`,
    method: 'delete',
  });
}

/**
 * @description 卡密库 -- 添加卡密
 */
export function cardSecretSaveApi(data: any) {
  return request({
    url: 'product/cdkey/create',
    method: 'post',
    data,
  });
}

/**
 * @description 卡密库 -- 卡密列表
 */
export function cardSecretPageListApi(data: any) {
  return request({
    url: 'product/cdkey/lst',
    method: 'get',
    params: data,
  });
}

/**
 * @description 卡密库 -- 编辑卡密
 */
export function cardSecretUpdateApi(id: number | string, data: any) {
  return request({
    url: `product/cdkey/update/${id}`,
    method: 'post',
    data,
  });
}

/**
 * @description 卡密库 -- 删除卡密
 */
export function cardSecretDeleteApi(id: number | string) {
  return request({
    url: `product/cdkey/delete/${id}`,
    method: 'delete',
  });
}

/**
 * @description 卡密库 -- 导入卡密
 */
export function cardSecretImportExcelApi(data: any) {
  return request({
    url: 'product/cdkey/library/import/cdkey',
    method: 'post',
    data,
  });
}

/**
 * @description 卡密库 -- 导入卡密
 */
export function cardSecretBatchDeleteApi(data: any) {
  return request({
    url: 'product/cdkey/batch_delete',
    method: 'delete',
    data,
  });
}

/**
 * @description 卡密库 -- 导出卡密
 */
export function cardSecretExportExcelApi(data: any) {
  return request({
    url: 'excel/download/cdkey',
    method: 'get',
    params: data,
  });
}

/**
 * @description 卡密库 -- 下拉筛选
 */
export function productUnrelatedListApi() {
  return request({
    url: 'product/cdkey/library/options',
    method: 'get',
  });
}

/**
 * @description 预约设置 -- 保存配置
 */
export function configTypeApi(type: string, data: any) {
  return request({
    url: `config/${type}`,
    method: 'post',
    data,
  });
}

/**
 * @description 预约设置 -- 获取配置
 */
export function getConfigDataApi() {
  return request({
    url: 'config',
    method: 'get',
  });
}


/**
 * 获取活动标签列表
 */
export function labelOptionsApi() {
  return request({
    url: 'activity/label/options',
    method: 'get',
  });
}

/**
 * 设置活动标签
 * @param {*} productIdList 商品ID列表
 * @param {*} labelIdList 标签ID列表
 * @param {*} isOverwrite 是否覆盖原有标签 1:覆盖 2:新增
 * @returns
 */
export function setActivityLabelApi(productIdList:number[], labelIdList:number[], isOverwrite = false) {
  return request({
    url: `activity/label/batch_create`,
    method: 'post',
    data:{
      productIds: productIdList,
      labelIds: labelIdList,
      type: isOverwrite ? 1 : 2
    },
  });
}

/**
 * 获取活动标签下拉列表
 */
export function getActivityLabelList() {
  return request({
    url: 'activity/label/select',
    method: 'get',
  });
}

/**
 * @description 商品统计 -- 商品排行
 */
export function productTopApi(data:any) {
  return request({
    url: 'analytics/product/top',
    method: 'get',
    params: data,
  });
}

/**
 * @description 商品统计 -- 商品折线图
 */
export function productLineChartApi(data:any) {
  return request({
    url: 'analytics/product/line_chart',
    method: 'get',
    params: data,
  });
}

/**
 * @description 商品统计 -- 一般商品饼图
 */
export function productPieChartApi(type:number,data:any) {
  return request({
    url: `analytics/product/pie_chart/${type}`,
    method: 'get',
    params: data,
  });
}

/**
 * @description 商品统计 -- 活动商品饼图（活动分类 / 活动形态）
 */
export function activityProductPieChartApi(type: number, data: any) {
  return request({
    url: `analytics/product/activity_pie_chart/${type}`,
    method: 'get',
    params: data,
  });
}



//缺失方法 补充
/**
 * @description 导入卡密
 */
export function importCard(data:any) {
  return request({
    url: 'product/product/import_card',
    method: 'get',
    params: data,
  });
}